import { ArrowLeft, ArrowRight, Heart, ArrowSquareOut, Eye } from "@phosphor-icons/react";
import { useRef } from "react";
import { tweets } from "@/data/tweets";

export function TweetCarousel() {
  const track = useRef<HTMLDivElement>(null);
  const move = (direction: number) => track.current?.scrollBy({ left: direction * 420, behavior: "smooth" });

  return (
    <section className="voices section" id="voices" aria-labelledby="voices-title">
      <div className="section-head">
        <div>
          <p className="eyebrow">Seen in the wild</p>
          <h2 id="voices-title">The timeline put the bag on.</h2>
        </div>
        <div className="carousel-controls" aria-label="Tweet carousel controls">
          <button className="icon-button" onClick={() => move(-1)} aria-label="Previous posts"><ArrowLeft size={20} /></button>
          <button className="icon-button" onClick={() => move(1)} aria-label="Next posts"><ArrowRight size={20} /></button>
        </div>
      </div>
      <div className="tweet-track" ref={track}>
        {tweets.map((tweet, index) => (
          <article className="tweet-card" key={tweet.id}>
            <div className="tweet-index">0{index + 1}</div>
            <div className="tweet-author">
              <div className="bagged-avatar">
                <img src={tweet.avatar} alt="" loading="lazy" />
              </div>
              <div>
                <strong>{tweet.name}</strong>
                <span>@{tweet.handle} · {tweet.followers}</span>
              </div>
            </div>
            <p className="tweet-text">“{tweet.text}”</p>
            {tweet.context && <p className="tweet-context">{tweet.context}</p>}
            <footer>
              <span><Heart size={16} weight="fill" /> {tweet.likes}</span>
              <span><Eye size={16} /> {tweet.views}</span>
              <a href={`https://x.com/${tweet.handle}/status/${tweet.id}`} target="_blank" rel="noreferrer" aria-label={`Open ${tweet.name}'s post on X`}><ArrowSquareOut size={18} /></a>
            </footer>
          </article>
        ))}
      </div>
      <p className="data-note">Public X metrics captured September 5, 2026. Counts keep moving.</p>
    </section>
  );
}
